import { useCallback, useContext } from 'react';

import { useDialog } from '@shared/hooks';
import { useAppDispatch } from 'store';

import { ProgressContext } from '../../../Context/ProgressContext';

export const useMassSelection = () => {
    const dispatch = useAppDispatch();

    const { isOpen, open, close } = useDialog();

    const {
        isActiveMassSelectMode,
        activeMassSelectModeHandle,
        selectedMassMediaIds,
        onSelectedMassMediaIds,
        onALLSelectedMassMediaIds,
    } = useContext(ProgressContext);
    return {
        isActiveMassSelectMode,
        activeMassSelectModeHandle,
        selectedMassMediaIds,
        onSelectedMassMediaIds,
        onALLSelectedMassMediaIds,
        open,
        isOpen,
        close,
    };
};
